module.exports = __webpack_public_path__ + "img/noImage.5e98ec87.jpg";